<template>
    <title>Log In</title>

    <body @keyup.enter="login">
    <div class="header">
        <h2>Log In</h2>
    </div>
    <div>
        <br>
            <form method="post" name="fp_loginPage" id="fp_loginPage" class="login">
                <br>
                    <br>
                        <div>
                            <label style="width: inherit" for="userName">Username*</label>
                            <input @keyup.enter="login" type="text" name="userName" id="userName" class="mandatory" style="width: 60% margin:" v-model="userName" required/>
                            <div v-if="showUserNameRequiredNotification" class="error text-sm mb-2" style="color: #red">
                                This field is required.
                            </div> 
                        </div>
                        <div id="passwordSection">
                            <label for="password">Password*</label>
                            <input @keyup.enter="login" type="password" name="password" id="password" class="mandatory" v-model="password" required/>
                            <div v-if="showPasswordRequiredNotification" class="error text-sm" style="color: #red">
                                This field is required.
                            </div> 
                        </div>
                        
                        <br>
                        <div v-if="loading" type="hidden" id="pleaseWait" class="pleaseWait text-gray-600" name="pleaseWait"> 
                            Please Wait... 
                        </div>
                        <div v-if="showNotification" id="errorLogin" class="error" style="color: #red">
                            Error: Wrong username and/or password
                        </div> 
                        <div id="nav-buttons">
                            <button id="btnLogin" class="button" type="button" @click="login" >Login</button>
                        </div>
                        <input type="hidden" name="formHasBeenSubmitted" id="formHasBeenSubmitted" value="1" />
                        <input type="hidden" name="cmd" id="cmd" />

            </form>

    </div><!-- end of #content -->

    </body>
</template>

<script>
    import loginAPI from './loginAPI.ts'
    //import store from '@/store/index.ts'
    import { defineComponent, ref } from 'vue'
    import { useStore } from 'vuex'

    export default defineComponent({
        name: 'User Login',
        setup() {
            const userName = ref('')
            const password = ref('')
            const isError = ref(false)
            const loading = ref(false)
            const message = ref('')
            const showNotification = ref(false)
            const showPasswordRequiredNotification = ref(false)
            const showUserNameRequiredNotification = ref(false)
            const store = useStore()

            //Login function to log user in
            async function login() {
                if (userName.value == '' || password.value == ''){
                    showPasswordRequiredNotification.value = false
                    showUserNameRequiredNotification.value = false
                    if (userName.value == ''){showUserNameRequiredNotification.value = true}
                    if (password.value == ''){showPasswordRequiredNotification.value = true}
                    showNotification.value = false
                    return
                }
                loading.value = true
                await loginAPI.login(userName.value, password.value, response =>{
                    if(response.authenticated === true) {
                        store.commit('setUserData', response.user);
                        this.$router.push({ name: 'Dashboard'})//, params: {firstName: store.state.user.firstName}})
                    } else {
                        isError.value = true
                        message.value = response.message
                        showNotification.value = true
                        showPasswordRequiredNotification.value = false
                        showUserNameRequiredNotification.value = false
                        loading.value = false
                        // setTimeout(() => {
                        //     isError = false
                        //     message = ""
                        //     showNotification = false
                        // }, 3000);
                    }
                })
            }

            return {
                userName,
                password,
                isError,
                message,
                loading,
                showNotification,
                login,
                store,
                showUserNameRequiredNotification,
                showPasswordRequiredNotification,
            }
        }
    })
</script>

<style scoped>
    button{
        margin-left: 0 !important;
        width: 80% !important;
        height: 50px !important;
        margin-left: 10% !important;
        margin-right: 10% !important;
        margin-bottom: 5% !important;
    }

    div.error{
       width: 80%;
       margin-left: 10%;
       margin-right: 10%;
       font-weight: bold;
       color: red;
     }

    div.pleaseWait{
       width: 80%;
       margin-left: 10%;
       margin-right: 10%;
       font-weight: bold;
     }

    form.login{
      clear:both;
      margin-left: auto;
      margin-right: auto;
      border: solid RGB(210, 210, 210) 1px;
      width: 50%;
    }

    label {
       display: block;
       margin-bottom: 5px;
       margin-left: 10%;
       margin-right: 10%;
     }

    label.error {
       font-weight:normal;
     }

    span.required{
       color:#900;
     }

    ul#menu-top-tier.menu {

      display: none;

     }
</style>